// ============================================
// CONTAINER PRINCIPAL - BOOK VECTORIZATION
// ============================================
// Este é a "página" principal do módulo
// Renderiza: Header + Tabela + Modal
// ============================================

import React, { Component } from 'react'
import Layout from '../../components/Layout'
import CrudHeader from '../../components/CrudHeader'
import UserToolbar from '../../components/UserToolbar'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { bookVectorizationActions } from '../../actions'
import { crudListStyle } from '../../styles'
import VetorizacaoNav from '../../components/VetorizacaoNav'
import BookVectorizationFlow from '../../components/BookVectorizationFlow'

class BookVectorization extends Component {
  // ========================================
  // LIFECYCLE - Limpa estado ao sair da página
  // ========================================
  componentWillUnmount() {
    const { resetState } = this.props
    // Reseta estado para não deixar dados "velhos" em memória
    resetState()
  }

  render() {
    // ========================================
    // PROPS - Vindas do Redux
    // ========================================
    const {
      modalOpen, // Se modal está aberto
      openModal, // Função para abrir modal
      closeModal, // Função para fechar modal
      newBookVectorization, // Função para criar novo (limpa form)
      classes, // Estilos CSS
      token, // Token JWT do usuário
    } = this.props

    return (
      // ========================================
      // LAYOUT - Container com menu lateral
      // ========================================
      <Layout toolBarRight={UserToolbar}>
        {/* ====================================== */}
        {/* HEADER - Título + Botão "Novo" */}
        {/* ====================================== */}
        <CrudHeader
          title={'Vetorização de Livros'} // Título que aparece no topo
          classes={classes} // Estilos CSS
          newResource={newBookVectorization} // Função ao clicar "Novo"
          openModal={openModal} // Abre modal
          closeModal={closeModal} // Fecha modal
          token={token} // Token para verificar permissões
          functionality={'vetorizacaoLivros'} // Nome da permissão no sistema
        />

        <VetorizacaoNav active="livros" />
        <BookVectorizationFlow />

        {/* ====================================== */}
        {/* TABELA - Lista todos os livros */}
        {/* ====================================== */}
        <ListTable />

        {/* ====================================== */}
        {/* MODAL - Formulário criar/visualizar */}
        {/* ====================================== */}
        <EditModal
          open={modalOpen} // Controla visibilidade do modal
          onClose={closeModal} // Função para fechar
        />
      </Layout>
    )
  }
}

// ============================================
// REDUX - Conecta ESTADO ao componente
// ============================================
// Transforma estado do Redux em props do componente
const mapStateToProps = (state) => {
  return {
    // Pega estado do modal do Redux
    modalOpen: state.bookVectorization.modalOpen,

    // Pega token de autenticação
    token: state.auth.token,
  }
}

// ============================================
// REDUX - Conecta ACTIONS ao componente
// ============================================
// Transforma actions em props (funções que o componente pode chamar)
const mapDispatchToProps = (dispatch) => {
  return {
    // Abre o modal
    openModal: () => {
      dispatch(bookVectorizationActions.openModal())
    },

    // Fecha o modal
    closeModal: () => {
      dispatch(bookVectorizationActions.closeModal())
    },

    // Prepara formulário novo (limpo)
    // Chamado ao clicar no botão "Novo"
    newBookVectorization: () => {
      dispatch(bookVectorizationActions.newFormBookVectorization())
    },

    // Reseta todo o estado do módulo
    // Chamado quando sai da página
    resetState: () => {
      dispatch(bookVectorizationActions.resetState())
    },
  }
}

// ============================================
// EXPORTA componente conectado ao Redux e com estilos
// ============================================
export default connect(
  mapStateToProps, // Lê dados do Redux
  mapDispatchToProps, // Conecta ações do Redux
)(withStyles(crudListStyle)(BookVectorization)) // Aplica estilos CSS



// WEBPACK FOOTER //
// ./src/containers/BookVectorization/index.js